/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { Link } from 'react-router-dom';
import { UncontrolledCollapse, NavbarBrand, Navbar, NavItem, NavLink, Nav, Container, Row, Col } from 'reactstrap';

const sachsoLogoUrl = require('assets/img/brand/sachso_logo.png').default;

function AdminNavbar() {
  return (
    <>
      <Navbar className='navbar-horizontal navbar-main navbar-dark navbar-transparent' expand='lg' id='navbar-main'>
        <Container>
          <NavbarBrand to='/' tag={Link}>
            <img alt='Sách số' src={sachsoLogoUrl} style={{ marginTop: -10 }} />
          </NavbarBrand>
          <button aria-controls='navbar-collapse' aria-expanded={false} aria-label='Toggle navigation' className='navbar-toggler' data-target='#navbar-collapse' data-toggle='collapse' id='navbar-collapse' type='button'>
            <span className='navbar-toggler-icon' />
          </button>
          <UncontrolledCollapse className='navbar-custom-collapse' navbar toggler='#navbar-collapse'>
            <div className='navbar-collapse-header'>
              <Row>
                <Col className='collapse-brand' xs='6'>
                  <Link to='/'>
                    <img alt='Sách số' src={sachsoLogoUrl} style={{ marginTop: -8 }} />
                  </Link>
                </Col>
                <Col className='collapse-close' xs='6'>
                  <button aria-controls='navbar-collapse' aria-expanded={false} aria-label='Toggle navigation' className='navbar-toggler' data-target='#navbar-collapse' data-toggle='collapse' id='navbar-collapse' type='button'>
                    <span />
                    <span />
                  </button>
                </Col>
              </Row>
            </div>
            <Nav className='mr-auto' navbar>
              <NavItem>
                <a className='nav-link' href='https://phuongnam.edu.vn' target='_blank' rel='noopener noreferrer'>
                  <span className='nav-link-inner--text' style={{ fontSize: 14 }}>
                    Trang chủ
                  </span>
                </a>
              </NavItem>
              <NavItem>
                <NavLink to='/' tag={Link}>
                  <span className='nav-link-inner--text' style={{ fontSize: 14 }}>
                    Đăng nhập
                  </span>
                </NavLink>
              </NavItem>
              <NavItem>
                <a className='nav-link' href='https://hanhtrangso.nxbgd.vn' target='_blank' rel='noopener noreferrer'>
                  <span className='nav-link-inner--text' style={{ fontSize: 14 }}>
                    Đăng ký
                  </span>
                </a>
              </NavItem>
            </Nav>
          </UncontrolledCollapse>
        </Container>
      </Navbar>
    </>
  );
}

export default AdminNavbar;
